module.exports = __webpack_public_path__ + "img/footer-border.64161113.png";